import {useEffect, useRef, useState, useCallback} from 'react';
import {graphSettings} from '../helpers/configs';

export function useRowObscured(
  shouldGraphStick,
  scrollContainerRef = null,
  stickyRegionHeightPx = graphSettings.wrapperHeightSticky
) {
  const rowRef = useRef(null);
  const [isObscured, setIsObscured] = useState(false);

  const checkObscurity = useCallback(() => {
    if (!rowRef.current) return;

    const rect = rowRef.current.getBoundingClientRect();
    const distanceToBottom = window.innerHeight - rect.bottom;
    const newIsObscured = distanceToBottom < stickyRegionHeightPx && shouldGraphStick;

    setIsObscured(prev => (prev !== newIsObscured ? newIsObscured : prev));
  }, [shouldGraphStick, stickyRegionHeightPx]);

  useEffect(() => {
    const scrollElement = scrollContainerRef?.current || window;

    checkObscurity();

    scrollElement.addEventListener('scroll', checkObscurity, {passive: true});
    if (scrollContainerRef?.current) {
      window.addEventListener('scroll', checkObscurity, {passive: true});
    }
    window.addEventListener('resize', checkObscurity, {passive: true});

    return () => {
      scrollElement.removeEventListener('scroll', checkObscurity);
      window.removeEventListener('scroll', checkObscurity);
      window.removeEventListener('resize', checkObscurity);
    };
  }, [checkObscurity, scrollContainerRef]);

  useEffect(() => {
    if (rowRef.current) {
      const id = requestAnimationFrame(checkObscurity);
      return () => cancelAnimationFrame(id);
    }
  }, [checkObscurity]);

  return [rowRef, isObscured];
}

export default useRowObscured;
